import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../../apiconfig";

function Instruction({ onNext }) {
	
	const [isEditOn, setIsEditOn] = useState(false);
	   useEffect(() => {
	       const checkPaymentStatus = async () => {
	           try {
	               const token = sessionStorage.getItem("token");

	               const response = await fetch(
	                   `${API_BASE_URL}/API/Student/EDIT_ON_OFF`,
	                   {
	                       method: "GET",
	                       headers: {
	                           "Authorization": "Bearer " + token
	                       }
	                   }
	               );

	               if (!response.ok) return;

	               const result = await response.json();
	               console.log("edit response:", result);

	               setIsEditOn(result);



	           } catch (error) {
	               console.error("Error checking payment:", error);
	           }
	       };

	       checkPaymentStatus();
	   }, []);

	   //const canEdit = !isPaymentDone || isEditOn === false;

	   const canEdit = isEditOn === false;

	
	
	return (
		<>
			<style>{`
				@keyframes smoothEntry {
				  0% {
				    opacity: 0;
				    transform: translateY(20px);
				  }
				  100% {
				    opacity: 1;
				    transform: translateY(0);
				  }
				}

				.container {
				  background: #fff;
				  padding: 14px;
				  border-radius: 10px;
				  border: 1px solid #e2e8f0;
				  font-family: 'Poppins', sans-serif;

				  display: flex;
				  flex-direction: column;

				  flex: 1;
				  min-height: 0;
				  overflow: hidden;

				  /* 🔥 Animation */
				  animation: smoothEntry 0.4s ease;
				}
		
		.container {
		  background: #fff;
		  padding: 18px;
		  border-radius: 12px;
		  border: 1px solid #e2e8f0;

		  width: 100%;
		  max-width: 850px;   /* 🔥 KEY FIX */
		}

        .title {
          font-size: 16px;
          font-weight: 600;
          color: #1e3a8a;
          margin-bottom: 8px;
        }

        .download {
          background: #eef2ff;
          padding: 8px;
          border-radius: 6px;
          font-size: 12px;
          margin-bottom: 10px;
        }

        .download a {
          display: block;
          color: #2563eb;
          text-decoration: none;
          margin-top: 2px;
        }

		.content {
		  flex: 1;
		  overflow-y: auto;
		  min-height: 0;   /* 🔥 CRITICAL */
		}
		.content {
		  scroll-behavior: smooth;
		}

        .list {
          font-size: 12.5px;
          color: #334155;
          padding-left: 18px;
        }

        .list li {
          margin-bottom: 10px;
          line-height: 1.5;
        }

        .highlight {
          background: #fff7ed;
          border-left: 3px solid #f97316;
          padding: 5px 6px;
          border-radius: 4px;
          margin-top: 5px;
          font-size: 11.5px;
        }

        .footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
        }

        .note {
          font-size: 11px;
          color: #64748b;
        }

        .next-btn {
          padding: 7px 14px;
          background: #2563eb;
          color: #fff;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 12px;
        }

        .next-btn:hover {
          background: #1d4ed8;
        }
		.btn-disabled {
		    filter: blur(1px);
		    opacity: 0.5;
		    cursor: not-allowed;
		    pointer-events: none;
		}
      `}</style>

			<div className="container">
				<div className="title">Instructions</div>

				{/* Download */}
				<div className="download">
					<b>Download Information Brochure:</b>
					<a href="#">a. JLEE Information Brochure</a>
					<a href="#">b. JMEE Information Brochure</a>
				</div>

				{/* Instructions */}
				<div className="content">
					<ol className="list">

						<li>
							Before filling the Online Application Form DOWNLOAD INFORMATION BROCHURE and read the same carefully.
						</li>

						<li>
							Fill the Online Application Form carefully and upload scanned photograph and signature.
							<div className="highlight">
								Photo: 20–35kb | Signature: 15–30kb | Format: .jpg / .jpeg
							</div>
						</li>

						<li>
							Please note that, if any mistake is committed by the candidate while filling the online Application Form, it cannot be corrected after final submission of forms.
						</li>

						<li>
							The Applicant's must possess the required criteria and education qualification as mentioned in the Information Brochure.
						</li>

						<li>
							After reading above instructions to fill the Online Application Form, the Applicant has to click Next button to display the Online Application Form.
						</li>

						<li>
							Applicants are requested to keep track of their fee status by re-login in, using their Application number & Password, If Payment status shows "Payment status pending" kindly call Technical Help Line number immediately - 8108014947,7977259728. University will not be held responsible of failure transactions.
						</li>

						<li>
							Admit Card will not be generated in any circumstances if payment is pending or not paid before the online application closing date.
						</li>

						<li>
							The Admit Card is issued only to appear in the OMR based examination. Candidates can not claim his/her selection by producing the Admit card.
						</li>

						<li>
							Candidate must ensure payment of fees within the last date of submission of online applications. Otherwise his/her candidature will not be considered for examination.
						</li>

						<li>
							If JLEE/JMEE- fee payment status is "Pending" for more than two (02) working days, Candidates are requested to contact concerned bank from which payment has been initiated. If the payment is failed, then candidates are again required to pay the Application Fee from the Login portal of If JLEE/JMEE-2026
						</li>

						<li>
							No communication regarding failure of payment, received after the last date of submission of online applications, will be entertained.
						</li>

					</ol>
				</div>

				{/* Footer */}
				<div className="footer">
					<div className="note">
						Please read all instructions carefully.
					</div>
					<button
					        className={`next-btn ${!canEdit ? "btn-disabled" : ""}`}
					        onClick={onNext}
					        disabled={!canEdit}
					    >
					        Next ➜
					    </button>
				</div>
			</div>
		</>
	);
}


export default Instruction;